import { render, staticRenderFns } from "./AirRoadJobs.vue?vue&type=template&id=5edb5c32&scoped=true"
import script from "./AirRoadJobs.vue?vue&type=script&lang=ts"
export * from "./AirRoadJobs.vue?vue&type=script&lang=ts"
import style0 from "./AirRoadJobs.scss?vue&type=style&index=0&id=5edb5c32&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edb5c32",
  null
  
)

export default component.exports